const initWidjet = () => {
  const widget = document.querySelector("[data-widget]");
  if (!widget) return;
    
  const trackScroll = () => {
    window.scrollY > 300
      ? widget.style.opacity = "1"
      : widget.style.opacity = "0";
  };
  
  trackScroll();
  window.addEventListener("scroll", trackScroll);

  /* Метрики на виджет */
  const widgetIcon = widget.querySelector("[data-widget-icon]");
  const widgetLink = widget.querySelector("[data-widget-link]");
  const isHoverableDevice = window.matchMedia("(hover: hover)");

  isHoverableDevice.matches
    ? widgetIcon.addEventListener("mouseenter", () => ym(94760218,'reachGoal','hover_widget'))
    : widgetIcon.addEventListener("click", () => ym(94760218,'reachGoal','hover_widget'));

  widgetLink.addEventListener("click", () => ym(94760218,'reachGoal','click_widget'));
};

export default initWidjet;
